import React, { Component } from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
import { NitroParagraph, NitroIcon, NitroButton } from "nitro-components";

import Container from "../../../../components/layouts/Container";
import SummarySection from "./SummarySection";

import { Source, Fields, Schedule, Filters } from "./Sections";

const Header = styled.div`
  background-color: ${props => props.theme.color.secondary};
  height: 300px;
  overflow: hidden;
`;

const BackgroundIcon = styled.div`
  position: absolute;
  left: 0;
  top: 50px;
  opacity: 0.05;
  z-index: 1;
`;

const ContentContainer = styled(Container)`
  position: relative;
`;

const HeaderContent = styled.div`
  height: 300px;
  width: 500px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const EditButtonWrapper = styled.button`
  border: 0;
  outline: 0;

  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);

  height: 40px;
  width: 40px;
  border-radius: 4px;

  background-color: rgba(255, 255, 255, 0.1);
  :hover {
    background-color: rgba(255, 255, 255, 0.05);
  }
`;

const titles = [
  {
    title: "Data source",
    step: 0,
    Component: Source
  },
  {
    title: "Selected fields",
    step: 1,
    Component: Fields
  },
  {
    title: "Condition filters",
    step: 2,
    Component: Filters
  },
  {
    title: "Schedule",
    step: 4,
    Component: Schedule
  }
];

class Summary extends Component {
  componentDidMount() {
    const submitLabel = (this.props.category === 'business')? 'FINISH AND BUILD REPORT': 'UPDATE REPORT';
    this.props.setNavigation({
      left: (
        <NitroButton
          action={this.props.navigation.goPrevious}
          labelVariant="secondary"
          label="PREVIOUS"
          size="extraSmall"
          leftIcon="arrow-left"
          leftIconVariant="secondary"
          insideIconSize={8}
        />
      ),
      middle: null,
      right: (
        <NitroButton
          action={this.props.navigation.goNext}
          label={submitLabel}
          variant="primary"
          size="extraSmall"
          icon="tick"
          insideIconSize={8}
        />
      )
    });
  }

  goToDetail = () => {
    this.props.navigation.goToStep(3);
  };

  render() {
    const { reportName, reportDescription } = this.props;
    return (
      <div>
        <Header>
          <ContentContainer>
            <BackgroundIcon>
              <NitroIcon
                name="clip-board"
                variant="white"
                opacity={0.05}
                size={300}
              />
            </BackgroundIcon>
            <EditButtonWrapper onClick={this.goToDetail}>
              <NitroIcon name="edit" variant="white" size={14} />
            </EditButtonWrapper>
            <HeaderContent>
              <NitroParagraph noMargin size="30" variant="white" align="center">
                {reportName}
              </NitroParagraph>
              <NitroParagraph variant="white" size="2" align="center">
                {reportDescription}
              </NitroParagraph>
            </HeaderContent>
          </ContentContainer>
        </Header>
        <Container>
          {titles.map(({ title, step, Component }) => (
            <SummarySection
              key={title}
              title={title}
              step={step}
              action={this.props.navigation.goToStep}
            >
              {Component &&
                <Component
                  step={step}
                  goToStep={this.props.navigation.goToStep}
                />}
            </SummarySection>
          ))}
        </Container>
      </div>
    );
  }
}

Summary.propTypes = {
  navigation: PropTypes.object,
  reportName: PropTypes.string,
  reportDescription: PropTypes.string
};

export default Summary;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Summary/Summary.js